import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import type { VehicleDetails } from 'Pages/vehicles/helpers/vehicle.schema';

export const useVehicleDetails = (): VehicleDetails => {
	const { details } = useVehicleData();

	return details;
};
